module.exports = __webpack_public_path__ + "img/error-404.aca518a8.svg";